import { PII_FIELD_MASKING_CLASS } from '@funnels/constants';

export const maskPIIFullStory = (str: string, key?: string) => (
  <span className={PII_FIELD_MASKING_CLASS} key={key}>
    {str}
  </span>
);
